const state = {
  categories: {},
};

const getters = {
  categories(state) {
    return state.categories;
  },
  categoriesFlatMap(_, getters){
    const flattenCats = (cats) => {
      return cats.reduce((obj, cat) => {
        obj[cat.id] = cat;
        return {...obj, ...flattenCats(cat.subCategories || [])}
      }, {})
    }

    return flattenCats(Object.values(getters.categories));
  },
  rootCategory(_, getters) {
    const flattenCats = (cats, parentId) => {
      return cats.reduce((obj, cat) => {
        obj[cat.id] = parentId || cat.id;
        return {...obj, ...flattenCats(cat.subCategories || [], parentId || cat.id)}
      }, {})
    }

    return flattenCats(Object.values(getters.categories));
  }
};

const mutations = {
  setCategories(state, payload) {
    state.categories = payload;
  },
};

const actions = {
  setCategories(context, payload) {
    context.commit('setCategories', payload);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
